import sdl from '@jds/react-generated-sdl/JDSInputFieldV2';
import type { JDSInputFieldV2Props } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputFieldV2Props } from '../logic';

const Component = (props: InputFieldV2Props) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'undefined',
    size = 'medium',
    type = 'text',
    disabled = false,
    ariaLabel = props.label?.toString(),
    dynamicButtonAriaLabel = props.dynamicButtonText?.toString(),
    _ariaplaceholder = props.placeholder?.toString(),
    _ariaRequired = props.required?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      state,
      size,
      type,
      disabled,
      ariaLabel,
      dynamicButtonAriaLabel,
      _ariaplaceholder,
      _ariaRequired,
      ...rest
    },
    'JDSInputFieldV2',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputFieldV2 = withLogic(Component) as React.ForwardRefExoticComponent<
  InputFieldV2Props & React.RefAttributes<HTMLInputElement>
> & { slotName?: string };

InputFieldV2.displayName = 'InputFieldV2';
InputFieldV2.slotName = 'jds_input_field_v_2';

export { InputFieldV2, type JDSInputFieldV2Props };
